import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import config from "../../config";

const ProtectedLayout = () => {
  const tokenCookie = Cookies.get("token", { domain: config.cookieDomain });
  const isPaidCookie = Cookies.get("role", { domain: config.cookieDomain });
  const isTestTaken = Cookies.get("isTestAttended", {
    domain: config.cookieDomain,
  });
  const usernameCookie = Cookies.get("username", {
    domain: config.cookieDomain,
  });
  const navigate = useNavigate();

  console.log(usernameCookie, "usernameCookie");

  useEffect(() => {
    if (tokenCookie) {
      if (isPaidCookie && isPaidCookie === "ROLE_UNPAID_USER")
        navigate("/home");
      if (isTestTaken && isTestTaken === "FALSE") navigate("/home");
    } else {
      window.location.href = config.domain + "/login";
    }
  }, [isPaidCookie, isTestTaken, navigate, tokenCookie]);

  return tokenCookie ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedLayout;
